import { render, staticRenderFns } from "./Nutrients.vue?vue&type=template&id=ef6cec92"
import script from "./Nutrients.vue?vue&type=script&lang=js"
export * from "./Nutrients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports